import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './tags-bar.css';

class TagsBar extends Component {
  render() {
    const tagsJSX = this.props.tags.map(({ id:tag, text, backgroundColor, isSVG, }) => {
      if (isSVG && backgroundColor) {
        return (
          <div 
            key={tag}
            className='tag-bar-image-container' 
            style={{ backgroundColor: (backgroundColor || 'inherit') }}>
              <img
                height='30'
                width='30'
                
                alt={text} 
                title={text} 
                src={`/images/article-tags/${tag}.svg`} />
        </div>
        )
      }
      
      return (
        <img        
          key={tag} 
          alt={text} 
          title={text} 
          src={`/images/article-tags/${tag}.${ isSVG ? 'svg' : 'png' }`} />
      );
    });

    return (
      <div className='tags-bar'>
        {tagsJSX}
      </div>
    );
  }
};

TagsBar.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string,
    isSVG: PropTypes.bool,
    backgroundColor: PropTypes.string,
  })),
};

TagsBar.defaultProps = {
  tags: []
};

export default TagsBar;